import * as React from 'react';

const SvgIconExpand = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={24} height={25} fill="none" {...props}>
    <path
      d="M9.75 15.248l-9 9M23.25 8.498v-6.75H16.5M.75 17.498v6.75H7.5M23.25 1.748l-9 9"
      stroke="#2B2B2B"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SvgIconExpand;
